(function () {
    'use strict';

    angular
        .module('ib-ancillaries-allianz-fusion-insurances-module')
        .controller('AllianzFusionController', AllianzFusionController);

    AllianzFusionController.$inject = ['$window', '$rootScope', 'MenusConstants', 'localStorageService', 'DatalayerMenusService'];
    function AllianzFusionController($window, $rootScope, MenusConstants, localStorageService, DatalayerMenusService) {
        const vm = this;
        vm.removeAllianzFusion = removeAllianzFusion;
        vm.deleteAllianzFusionSucess = deleteAllianzFusionSucess;

        $rootScope.$on('removeAllianzFusion', vm.removeAllianzFusion);


        function removeAllianzFusion() {
            setTimeout(() => {
                const actualPage = $window.location.hash.substring(2, 9), insurance = [{ type: 'ALLIANZ_FUSION' }];
                localStorageService.set('selectInsurance', false);
                vm.basketFunctions.isLoading();
                if (actualPage === MenusConstants.ANCILLARIES_PAGES_HASH.MMB) {
                    vm.deleteAllianzFusionSucess();
                } else {
                    vm.basketFunctions.deleteAncillariesService.deleteAncillarie(insurance).then(() => {
                        vm.deleteAllianzFusionSucess();

                    }, (error) => {
                        vm.basketFunctions.isNotLoading();
                        vm.basketFunctions.modalService.setErrorMessage(error.message);
                        vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                        vm.basketFunctions.modalService.isError(error);
                        vm.basketFunctions.collapseHeader.closeCollapse();
                    });
                }
            });
        }
        /**
         * Delete insurance of basket.
         * If the user is in the ancillaries page emits event for uncheck
         * insurances module
         */
        function deleteAllianzFusionSucess(actualPage = '') {
            $rootScope.$broadcast('deleteInsurance');

            DatalayerMenusService.deleteInsurance();

            vm.model.info = null;
            vm.model.hasInsuranceAllianzFusion = false;
            vm.model.total = null;
            vm.basketFunctions.calculateAllBasket(actualPage);
            vm.basketFunctions.saveHeaderModel();
            vm.basketFunctions.isNotLoading();
            localStorageService.set('allianzFusionSelected', false);
            localStorageService.set('insuranceAllianzFusionPassengerInfo', null);
            $rootScope.$broadcast('updateInsuranceSelectedStatus', false);
            localStorageService.set('hasSelectedInsurance', false);
            angular.element('ib-insurance-allianz-fusion').find('.ib-radio__input:checked').prop('checked', false);
            $rootScope.$broadcast('basketUpdateCommonHeader');
        }
    }
})();